import Sidebar from "./Sidebar";

export default function Layout({ children }) {
    return (
        <div className="min-h-screen flex bg-background text-foreground">
            <Sidebar />
            <main data-testid="main-content" className="flex-1 min-w-0">
                {children}
            </main>
        </div>
    );
}

export function PageHeader({ overline, title, description, actions, testid }) {
    return (
        <header
            data-testid={testid || "page-header"}
            className="px-8 lg:px-12 pt-10 pb-6 border-b border-border animate-fade-up"
        >
            <div className="flex items-end justify-between gap-6 flex-wrap">
                <div className="max-w-2xl">
                    {overline && <div className="overline mb-3">{overline}</div>}
                    <h1 className="font-display font-bold text-3xl md:text-4xl tracking-tight leading-[1.05]">
                        {title}
                    </h1>
                    {description && (
                        <p className="text-muted-foreground mt-3 text-sm md:text-[15px] leading-relaxed">
                            {description}
                        </p>
                    )}
                </div>
                {actions && <div className="flex gap-2 items-center">{actions}</div>}
            </div>
        </header>
    );
}

export function PageBody({ children }) {
    return (
        <div className="px-8 lg:px-12 py-8 animate-fade-up">{children}</div>
    );
}
